import { AspectRatio, Box, Flex, Img, Skeleton, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import PlayButton from "../../assets/svg/play_button";
import dynamic from "next/dynamic";

import { getYoutubeVideoDetails } from "../../utils/functions";

const VideoModal = dynamic(() => import("../../components/home/videoModal"), {
  ssr: false,
});

export function SocialComponent({ date }) {
  const jsDate = new Date(date);
  const month = jsDate.toLocaleString("default", { month: "long" });

  return (
    <Flex width={"100%"} pt="15px" pb="15px" flexDirection={"row"}>
      <Img
        src={
          `${process.env.NEXT_PUBLIC_EXTERNAL_WORDPRESS_URL}/wp-content/uploads/2020/10/WhatsApp-Image-2020-09-25-at-17.03.30.jpeg`
        }
        bg="light"
        lazy="true"
        borderRadius={20}
        height={"45px"}
        objectFit="cover"
        overflow="hidden"
        alt="product-image"
        fallback={<Skeleton w="100%" />}
        width={"45px"}
      />
      <Box ml="10px">
        <Text
          color="#2C3035"
          variant="cartItemDescription"
          fontFamily={"Lato"}
          fontWeight={"bold"}
        >
          Dr.Vasishth's Ayuremedies
        </Text>
        <Text variant="cartItemDescription" fontSize={"13px"} color={"#4E5867"}>
          {`${month} ${jsDate.getDate()}, ${jsDate.getFullYear()}`}
        </Text>
      </Box>
    </Flex>
  );
}

export const ImageComponent = ({ src }) => (
  <AspectRatio my={"5%"} width="100%" ratio={3 / 2}>
    <Img
      lazy="true"
      width="100%"
      alt="image-alt"
      overflow="hidden"
      objectFit="cover"
      src={src}
      borderRadius={5}
      _hover={{ cursor: "pointer" }}
      fallback={<Skeleton w="100%" />}
    />
  </AspectRatio>
);

export const VideoComponent = ({ src }) => {
  let [thumbnailImage, videoId] = getYoutubeVideoDetails(src);

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(videoId);

  const handleOpenVideoModal = (videoId) => {
    setActiveVideo(videoId);
    setIsVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setActiveVideo(null);
    setIsVideoModalOpen(false);
  };

  return (
    <>
      <Box
        my={"5%"}
        width="100%"
        key={videoId}
        position="relative"
        _hover={{ cursor: "pointer" }}
        onClick={() => handleOpenVideoModal(videoId)}
      >
        <AspectRatio width="100%" ratio={16 / 9}>
          <Img
            lazy="true"
            width="100%"
            alt="image-alt"
            overflow="hidden"
            objectFit="cover"
            borderRadius={5}
            src={thumbnailImage}
            _hover={{ cursor: "pointer" }}
            fallback={<Skeleton w="100%" />}
          />
        </AspectRatio>
        <Box top="45%" left="45%" position="absolute">
          <PlayButton width={40} height={40} />
        </Box>
      </Box>

      <VideoModal
        videoId={activeVideo}
        activeVideo={activeVideo}
        isVideoModalOpen={isVideoModalOpen}
        closeVideoModal={handleCloseVideoModal}
      />
    </>
  );
};
